import React, { useEffect, useState } from 'react';
import { API_BASE, withDhtUserId } from '../utils/api';

const toUtcIsoString = (dateTimeLocalValue) => {
  if (!dateTimeLocalValue) {
    return '';
  }

  const date = new Date(dateTimeLocalValue);
  return Number.isNaN(date.getTime()) ? '' : date.toISOString();
};

const BoxReserver = ({
  userId = '1',
  onReservationSuccess,
  selectedBoxId = '',
  lockBoxSelection = false,
  initialStartTime = '',
  initialEndTime = ''
}) => {
  const [newReservation, setNewReservation] = useState({
    userId: userId,
    boxId: selectedBoxId ? String(selectedBoxId) : '',
    startTime: initialStartTime,
    endTime: initialEndTime
  });

  // Use API_BASE from src/utils/api.js

  useEffect(() => {
    setNewReservation((currentReservation) => ({
      ...currentReservation,
      userId,
      boxId: selectedBoxId ? String(selectedBoxId) : currentReservation.boxId
    }));
  }, [selectedBoxId, userId]);

  useEffect(() => {
    setNewReservation((currentReservation) => ({
      ...currentReservation,
      startTime: initialStartTime,
      endTime: initialEndTime
    }));
  }, [initialStartTime, initialEndTime]);

  const handleReserve = async (e) => {
    e.preventDefault();
    try {
      const reservationPayload = {
        DHTUSR_id: newReservation.userId,
        DHTBOX_id: newReservation.boxId,
        DHTRSV_start_Date: toUtcIsoString(newReservation.startTime),
        DHTRSV_end_Date: toUtcIsoString(newReservation.endTime)
      };

      const response = await fetch(`${API_BASE}/reservations`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(withDhtUserId(reservationPayload))
      });
      
      const resData = await response.json();
      
      if (!response.ok) {
        throw new Error(resData.error || 'Failed to create reservation');
      }
      
      setNewReservation({
        ...newReservation,
        boxId: lockBoxSelection && selectedBoxId ? String(selectedBoxId) : '',
        startTime: '',
        endTime: ''
      });
      if (onReservationSuccess) {
        await onReservationSuccess();
      }
      alert('Reservation successful!');
    } catch (err) {
      alert('Error: ' + err.message);
    }
  };

  return (
    <div className="card home-card reservation-card h-100">
      <div className="card-body p-3 d-flex flex-column">
        <h6 className="card-title text-center mb-3">Reserve a Box</h6>
        <form onSubmit={handleReserve} className="flex-grow-1 d-flex flex-column">
          <div className="mb-3">
            <label className="form-label small mb-1 opacity-75">Target Box ID</label>
            <input
              type="number"
              className="form-control home-input"
              placeholder="e.g. 101"
              value={newReservation.boxId}
              onChange={(e) => setNewReservation({...newReservation, boxId: e.target.value})}
              readOnly={lockBoxSelection}
              required
            />
          </div>
          <div className="mb-3">
            <label className="form-label small mb-1 opacity-75">Start Date/Time</label>
            <input
              type="datetime-local"
              className="form-control home-input"
              value={newReservation.startTime}
              onChange={(e) => setNewReservation({...newReservation, startTime: e.target.value})}
              required
            />
          </div>
          <div className="mb-3">
            <label className="form-label small mb-1 opacity-75">End Date/Time</label>
            <input
              type="datetime-local"
              className="form-control home-input"
              value={newReservation.endTime}
              onChange={(e) => setNewReservation({...newReservation, endTime: e.target.value})}
              required
            />
          </div>
          <button type="submit" className="btn btn-home w-100 mt-2">
            Create Reservation
          </button>
        </form>
      </div>
    </div>
  );
};

export default BoxReserver;
